<td ng-class='highlightClass(projectNote.created, projectNote.updated);' 
    style='vertical-align: top;white-space:nowrap;'>
    {{projectNote.noteDate | date:'MMM yyyy'}}
</td>
<td></td>
<!-- ng-class='highlightClass(projectNote.created, projectNote.updated);'-->
<td [ngClass]="highlightService.class(projectNote.created, projectNote.updated)">
    <div style='font-weight:bold;'>Analyst's opinion ({{projectNote.editorJobTitle}})</div>
    <div style='margin-left:20px' [innerHTML]='projectNote.note | highlight: searchTerm'></div>
</td>

<!-- ng-class='highlightClass(noteType.created, noteType.created);' -->
<td style='vertical-align: top;white-space:nowrap;'>
    <ul class='list-unstyled ' *ngFor='let noteType of projectNote.noteTypes'>
        <li [ngClass]='highlightService.class(noteType.created, noteType.created)' *ngIf='noteType.noteTypeID != 7'>
            {{noteType.noteType}}
        </li>
    </ul>
</td>
<td>
</td>

